module.exports = __webpack_public_path__ + "img/dsal_logo.c60fa9b4.png";